<template>
  <div class="sapceDataDetailBox clearfix">
    <div class="leftBox">
      <h4 class="title">
        {{ tblinfo.showTableName }}
      </h4>
      <button class="backBtn" style="" @click="backToPersonal">返回</button>
      <div class="line"></div>

      <el-table
        v-if="nowClickBtn"
        element-loading-text='正在加载空间数据'
        v-loading="sptlDataLoading"
        :data="sptlDataList"
        style="width: 100%;">
        <el-table-column
          v-for="(meta, index) in sptlMetaList"
          :key="index"
          :prop="meta"
          :label="meta"
          width="120">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" :disabled="ifShowOverflow(scope.row, meta)">
              <div style="max-width: 300px;max-height:300px;overflow-y:scroll">
                {{ scope.row[meta] }}
              </div>
              <div slot="reference" class="name-wrapper">
                <span size="medium">{{ showOverflow(scope.row, meta)	}}</span>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="!nowClickBtn">
        <!-- <div id="map-main" style="width:100%;height:400px"/>  -->
        <div  ref="basicMapbox" :style="vectorCss" v-loading="sptlDatamapLoading"> </div>
        <img :style="gridCss" :src="gridUrl" alt="" class="mapImg"/>
      </div>

    


      <el-pagination
        v-if="nowClickBtn"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout="sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <div class="rightBox">
      <div class="topBtnBox">
        <button :class="[nowClickBtn?'showListBtn':'showMapBtn']" @click="togglePage(1)">
          <img src="@/assets/images/icon35.png" alt="" v-if="loadIcon1"><img src="@/assets/images/icon35-1.png" alt="" v-if="loadIcon2">
          地图展示</button>
        <button :class="[nowClickBtn?'showMapBtn':'showListBtn']" @click="togglePage(2)">
          <img src="@/assets/images/icon36-1.png" alt="" v-if="loadIcon1"><img src="@/assets/images/icon36.png" alt="" v-if="loadIcon2">
          列表展示</button>
      </div>

      <h5 class="tableTitle"><img src="@/assets/images/icon28.png" alt="">  空间坐标系:</h5>
      <p class="lineSizeLimit">{{ tblinfo.wktShortName }}</p>
      <h5 class="tableTitle"><img src="@/assets/images/icon29.png" alt="">  兴趣边界:</h5>
      <p class="lineSizeLimit">minX:{{ tblinfo.minX }}</p>
      <p class="lineSizeLimit">minY:{{ tblinfo.minY }}</p>
      <p class="lineSizeLimit">maxX:{{ tblinfo.maxX }}</p>
      <p class="lineSizeLimit">maxY:{{ tblinfo.maxY }}</p>
      <h5 class="tableTitle"><img src="@/assets/images/icon30.png" alt="">  空间数据类型:</h5>
      <p class="lineSizeLimit">{{ tblinfo.sptlDataType }}</p>
      <h5 class="tableTitle"><img src="@/assets/images/icon31.png" alt="">  数据库类别:</h5>
      <p class="lineSizeLimit">{{ tblinfo.databaseTypeName }}</p>
      <h5 class="tableTitle"><img src="@/assets/images/icon32.png" alt="">  空间数据说明:</h5>
      <p class="lineSizeLimit">{{ tblinfo.instruction }}</p>
      <h5 class="tableTitle"><img src="@/assets/images/icon33.png" alt="">  空间数据记录总数:</h5>
      <p class="lineSizeLimit">{{ total }}</p>
      <h5 class="tableTitle"><img src="@/assets/images/icon34.png" alt="">  空间表元数据信息:</h5>
      <el-table
        :data="metaDataList"
        height="200px"
        style="width: 100%;">
        <el-table-column
          prop="column_name"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="column_type"
          label="类型">
        </el-table-column>
      </el-table>
      
    </div>
  </div>
</template>

<script>
// 使用配置文件的VUE_APP_DR_URL作为axios的基础地址
import request from '@/utils/request'

//import common from './../../../public/arcgisjs/common.js';
// 导入esri-loader（地图渲染）
//import esriLoader from "esri-loader";
//import { loadCss } from "esri-loader";
import mapboxgl from "mapbox-gl";//加载MAPBOX
import 'mapbox-gl/dist/mapbox-gl.css'//加载MAPBOX
export default {
  name: 'sapceDataDetailBox',
  data(){
    return {
      metaDataList:[],
      sptlDataList:[],
      sptlMetaList:[],
      loadIcon1:false,
      loadIcon2:true,
      nowClickBtn:false,
      currentPage:1,
      size:10,
      total:0,
      form:{
        name:'',
        remark:''
      },
      gridCss:'',
      vectorCss:'',
      gridUrl:'',
      sptlDataLoading: false,
      sptlDatamapLoading: false
    }
  },
  props: {
    tblinfo: {
      type: Object,
      required: true
    }
  },
  created(){
    // 转换数据库类别为中文
    this.getlayerType();

    var importType = this.tblinfo.importType.toLowerCase();
    if (importType == 'shp') {
      this.gridCss = 'dislay:none;';
      this.vectorCss = 'width:100%;height:400px;';
      this.getMetaDataList();
      this.loadSpatialData();
    }
    if (importType == 'tif') {
      this.gridCss = 'max-width:100%;';
      this.vectorCss = 'dislay:none;';
    }
    this.loadMap();
  },
  mounted(){
    // 加载CSS
    // loadCss('/arcgisjs/arcgis_js_api/4.12/dijit/themes/claro/claro.css');
    // loadCss('/arcgisjs/arcgis_js_api/4.12/esri/css/main.css');
    // common.appConfig = common.getConfig();
    // window.common = common;
    // const esriOptions = {
    //   url: "/arcgisjs/arcgis_js_api/4.12/init.js",
    //   dojoConfig:{
    //     parseOnLoad: true,
    //     async: true,
    //     packages: [{ 
    //       name: '',
    //       location: ""
    //     }] 
    //   }
    // }
    // this.$nextTick(() => {
    //   if (!esriLoader.isLoaded()) {
    //     esriLoader.loadScript(esriOptions);
    //   }
    // })
  },
  methods:{
    getlayerType() {
      this.tblinfo.databaseTypeName = '';
      return new Promise((resolve, reject) => {
        request({url:'/portal/mydata/dict/getDatabaseType', method:'post',timeout: 1000 * 60 * 1})
        .then(response => {
          var layerTypes = response.data.data;
          if (layerTypes != null && layerTypes != undefined) {
            for (let i = 0; i < layerTypes.length; i++) {
              var layerType = layerTypes[i];
              if (layerType.value == this.tblinfo.databaseType) {
                this.tblinfo.databaseTypeName = layerType.name;
                // 这样赋值，视图也不会更新
                // this.$set(this.tblinfo, 'databaseTypeName', layerType.name);
                // 所以用强制更新
                this.$forceUpdate();
                break;
              }
            }
          }
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 加载空间地图：矢量和栅格
     */
    loadMap() {
      var importType = this.tblinfo.importType.toLowerCase();
      if (importType == 'shp') {
        this.initMap(this.tblinfo.itableName);
      }
      if (importType == 'tif') {
        var fileUrl = this.tblinfo.thumUrl;
        var endIndex = fileUrl.lastIndexOf('/');
        if (fileUrl.lastIndexOf('/') < 0) {
          endIndex = fileUrl.lastIndexOf('\\');
        }
        var filePath = fileUrl.substr(0, endIndex + 1);
        var fileName = fileUrl.substr(endIndex + 1);
        fileName = 'pvmImg-' + fileName;
        fileUrl = filePath + fileName;
        this.gridUrl = fileUrl;
      }
    },
    // 加载矢量地图
    initMap(itableName){
      this.sptlDatamapLoading = true;
    
      this.$nextTick(() => {
        const url = "/portal/mydata/spatialdata/getGeoJSON?tableName=" + itableName;
      
       
  var map = new mapboxgl.Map({
              container:this.$refs.basicMapbox,
             //center: [116.326984,39.984248],
             zoom: 5,
             style: {
                 "version": 8,
                 "sources": {
                     "composite": {
                         //矢量类型
                         "type": "geojson",
                         "data": url,
                         
                     }
                 },
                 "layers": [
                    {
                          "id": "polygonlayer",
                          "type": "fill",
                          "source": "composite",
                          "paint": {
                              "fill-color": "red",
                              "fill-opacity": 0.4
                          },
                          "filter": ["==", "$type", "Polygon"]
                      },
                      {
                        'id': 'pointlayer',
                        'type': 'circle',
                        'source': "composite",
                        "filter": ["==", "$type", "Point"],
                        'paint': {
                            // make circles larger as the user zooms from z12 to z22
                            'circle-radius': {
                                'base': 4,
                                'stops': [[12, 2], [22, 180]]
                            },
                            "circle-color": "#B42222"
                        },
                    },
                    {
                        'id': 'linelayer',
                        'type': 'line',
                        'source': "composite",
                        "filter": ["==", "$type", "LineString"],
                        "layout": {
                            "line-join": "round",
                            "line-cap": "round"
                        },
                        "paint": {
                            "line-color": "#BF93E4",
                            "line-width": 5
                        }
                    }
                ],
               
             }
         });
         var tblinfo=this.tblinfo
        map.on('load', ()=> {
          map.fitBounds([[tblinfo.minX,tblinfo.minY], [tblinfo.maxX,tblinfo.maxY]]);
          this.sptlDatamapLoading = false;
        })
      
        // var map = new mapboxgl.Map({
        //   container:this.$refs.basicMapbox,
        //   style: 'mapbox://styles/mapbox/light-v10',
        //   center: [-96, 37.8],
        //   zoom: 3
        // });
         
        //   map.on('load', function() {
        //       map.addSource('geodata', { type: 'geojson', data: url });
        //       map.addLayer({
        //           "id": "polygonlayer",
        //           "type": "fill",
        //           "source": "geodata",
        //           "paint": {
        //               "fill-color": "red",
        //               "fill-opacity": 0.4
        //           },
        //           "filter": ["==", "$type", "Polygon"]
        //       });
        //       map.addLayer({
        //         'id': 'pointlayer',
        //         'type': 'circle',
        //         'source': "geodata",
        //         "filter": ["==", "$type", "Point"],
        //         'paint': {
        //             // make circles larger as the user zooms from z12 to z22
        //             'circle-radius': {
        //                 'base': 1.75,
        //                 'stops': [[12, 2], [22, 180]]
        //             },
        //             "circle-color": "#B42222"
        //         }
        //     });
        //     map.addLayer({
        //         'id': 'linelayer',
        //         'type': 'line',
        //         'source': "geodata",
        //         "filter": ["==", "$type", "LineString"],
        //         "layout": {
        //             "line-join": "round",
        //             "line-cap": "round"
        //         },
        //         "paint": {
        //             "line-color": "#BF93E4",
        //             "line-width": 5
        //         }
        //     });
        //     console.log(map.getSource('geodata'))
        //     console.log(map.getSource('geodata').getBounds())
        //   });
      })
       
     /*
      // 加载的顺序不能混乱，比如"esri/map"在第一，Map就要在第一
      esriLoader.loadModules([
        "esri/Map", 
        "esri/layers/GeoJSONLayer",
        "esri/views/MapView"
      ])
      .then(([
        Map, 
        GeoJSONLayer,
        MapView
      ]) => {
        const url = "/portal/mydata/spatialdata/getGeoJSON?tableName=" + itableName;
        
      console.log(url)
        const geojsonLayer = new GeoJSONLayer({
          url: url,
          // copyright: "USGS Earthquakes"
        });

        const map = new Map({
          // basemap: "gray",
          layers: [geojsonLayer]
        });

        const view = new MapView({
          container: "map-main",
          center: [-168, 46],
          zoom: 5,
          map: map
        });
        // view.ui.components = [];//清空所有ESRI自带的组件（包括logo、放大缩小按钮）
        
        geojsonLayer.queryExtent(geojsonLayer.createQuery()).then(function(results){
          view.goTo(results.extent);  // go to the extent of the results satisfying the query
        });

      })
 */
    },
    /**
     * 是否显示Popover弹出框
     */
    ifShowOverflow(row, metaName) {
      // 获取当前单元格的数据
      var data = row[metaName];
      if (data == null || data == undefined) {
        return true;
      }
      // 转为字符串
      data = data + '';
      if (data.length > 30) {
        return false;
      }
      return true;
    },
    /**
     * 对Popover弹出框的内容进行编辑
     */
    showOverflow(row, metaName) {
      // 获取当前单元格的数据
      var data = row[metaName];
      if (data == null || data == undefined) {
        return '';
      }
      // 转为字符串
      data = data + '';
      if (data.length > 30) {
        data = data.substr(0,30) + '...';
      }
      return data;
    },
    /**
     * 加载空间表分页数据
     */
    loadSpatialData() {
      this.sptlDataLoading = true;
      var params = {
        databaseType: this.tblinfo.databaseType,
        itableName: this.tblinfo.itableName,
        size: this.size,
        current:this.currentPage
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/mydata/spatialdata/loadSpatialData', method:'post' ,params:params, timeout: 1000 * 60 * 5})
        .then(response => {
          this.sptlDataLoading = false;
          this.total = response.data.data.total;
          this.sptlDataList = response.data.data.records;
          // 获取元数据信息
          if (this.sptlDataList != null && this.sptlDataList.length != 0) {
            var firstSptlData = this.sptlDataList[0];
            this.sptlMetaList = [];
            for (var key in firstSptlData) {
              this.sptlMetaList.push(key);
            }
          }
          resolve(response.data)
        }).catch(error => {
          this.sptlDataLoading = false;
          reject(error)
        })
      })
    },
    getMetaDataList() {
      var params = {
        databaseType: this.tblinfo.databaseType,
        itableName: this.tblinfo.itableName,
        username: JSON.parse(localStorage.getItem('portalUserName'))
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/mydata/spatialdata/getMetaData', method:'post' ,params:params, timeout: 1000 * 60 * 1})
        .then(response => {
          this.metaDataList = response.data.data;
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //地图、列表切换
    togglePage(val){
      if(val == 1){
        this.nowClickBtn = false;
        this.loadIcon2 = true;
        this.loadIcon1 = false;
        // this.initMap(this.tblinfo.itableName);
        this.loadMap();
      }else{
        this.nowClickBtn = true;
        this.loadIcon1 = true;
        this.loadIcon2 = false;
        if (this.tblinfo.importType.toLowerCase() == 'shp') {
          this.loadSpatialData();
        }
      }
    },
    handleSizeChange(val){
      this.size = val;
      this.loadSpatialData();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.loadSpatialData();
    },
    //返回个人中心首页
    backToPersonal(){
      this.$emit('backPersonal',true)
    }
  }
}
</script>

<style scoped>
.sapceDataDetailBox{width:100%;text-align:left;}
.sapceDataDetailBox .title{border-left:2px solid #4da1ff;text-indent:10px;color:#4da1ff}
.sapceDataDetailBox .leftBox,.sapceDataDetailBox .rightBox{padding:20px;border-radius:5px;box-shadow:0 0 30px #dae5f0;}
.sapceDataDetailBox .leftBox{float:left;width:78%;position:relative;}
.sapceDataDetailBox .leftBox .backBtn{position:absolute;right:10px;top:12px;}
.sapceDataDetailBox .rightBox{float:right;width:20%;}
.sapceDataDetailBox .rightBox p{padding-left:18px;font-size:12px;color:#526281;}

.line{height:1px;margin:15px 0;border-bottom:1px solid #eee;}
.sapceDataDetailBox .tableTitle{margin:15px 0 5px;color:#a1aac4;font-size:12px;}
.sapceDataDetailBox .tableTitle img{vertical-align:middle;width:11px;}
.topBtnBox{margin-bottom:20px;text-align:center}
.sapceDataDetailBox >>> .el-table th>.cell{text-align:center}
.sapceDataDetailBox >>> .el-table__body tr td:first-child{background:#fff!important;}
.sapceDataDetailBox >>> .el-table__body tr:first-child td{border-top:0!important;}
.sapceDataDetailBox >>> .el-table th{background:#fafafa}
.showListBtn img,.showMapBtn img{vertical-align: middle;margin-top: -3px;width:16px;margin-right:2px;}
.lineSizeLimit{word-break:break-all;}
</style>
